module.exports = __webpack_public_path__ + "assets/in-5e2b1d889d7547387826dc19cbbd7a53.svg";